import ReactLoader from './react_loader'

ReactLoader.registerComponents({
  CutToSizeGroups: require('../components/CutToSizeGroup/CutToSizeGroups')
})
